<template>
  <div class="s-sticky-bar s-sticky-bar--shop">
    <div class="s-sticky-bar__options">
      <div class="s-sticky-bar__option" v-if="!showOffer">
        <div class="s-form-item">
          <div class="s-form-item__select">
            <select name="team" id="term" @change="onChangeTerm($event, $event.target.selectedIndex)" class="s-form-item__field s-form-item__field--select">
              <option v-for="(item,index) in wpData.general[0].shop_general_laufzeit" v-bind:value="item.shop_general_laufzeit_discount">{{ item.shop_general_laufzeit_title }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="s-sticky-bar__option" v-if="!showOffer">
        <div class="s-form-item">
          <div class="s-form-item__select">
            <select name="payment" id="payment" @change="onChangePayment($event, $event.target.selectedIndex)" class="s-form-item__field s-form-item__field--select">
              <option v-for="(item,index) in wpData.general[0].shop_general_payment" v-bind:value="item.shop_general_payment_discount">{{ item.shop_general_payment_title }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="s-sticky-bar__cta">
      <div class="s-sticky-bar__price" v-if="!showOffer">
        <span class="s-sticky-bar__price-tag">{{ totalPrice | toCurrency }}</span>
        <span class="s-sticky-bar__price-footnote">{{ priceFootnote }} ({{ taxString }})</span>
      </div>

      <div class="s-sticky-bar__price" v-if="showOffer">
        <span class="s-sticky-bar__price-tag">{{ offerPrice | toCurrency }}</span>
        <span class="s-sticky-bar__price-footnote">({{ taxString }})</span>
      </div>

      <div class="s-buttons">
        <div @click="checkAddressForm" class="s-button s-button--primary s-button--l s-button--icon s-button--stripe" v-bind:class="{ 's-button--disabled' : this.$store.state.addressComplete !== true }">
          <template v-if="!checkoutLoading">
            <span class="s-button__text">{{ checkoutBtn }}</span>
          </template>
          <template v-if="checkoutLoading">
            <div class="s-spinner" data-theme="dark">
              <div class="s-spinner__left"></div>
              <div class="s-spinner__right"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  computed: {
    checkoutBtn(){
      return this.$store.state.wpdata[wpGlobalData.language].translations.slang_buttons[0].slang_buttons_primary;
    },
    taxString(){
      return this.$store.state.wpdata[wpGlobalData.language].translations.slang_other[0].slang_tax;
    },
    totalPrice: function (){
      let calcValues = this.$store.state.values;
      let totals = (((calcValues.price_streaming + calcValues.price_analyse + calcValues.price_camera) * (1 - (calcValues.term_discount / 100))) * (1 - (calcValues.payment_discount / 100)));
      if(calcValues.payment_type === 'one-off'){
        totals = totals * calcValues.term_month;
      }else if(calcValues.payment_type === 'yearly'){
        totals = totals * 12;
      }
      return totals;
    },
    offerPrice(){
      return this.$store.state.wpdata[wpGlobalData.language].offer.offer_details[0].offer_price;
    },
    priceFootnote() {
      return this.$store.state.values.payment_type_name;
    },
    wpData() {
      return this.$store.getters.wpdata[wpGlobalData.language];
    },
    selections() {
      return this.$store.state.selections;
    },
    showOffer(){
      return this.$store.state.showOffer && this.$store.state.wpdata[wpGlobalData.language].offer.activate_offer;
    }
  },
  data() {
    return {
      wpGlobalData,
      checkoutLoading: false
    };
  },
  mounted() {
    let s_shopbarHeight = jQuery(".s-sticky-bar").outerHeight();
    jQuery(".s-shop-select").css("padding-bottom", s_shopbarHeight);
  },
  methods: {
    onChangeTerm(event, selectedIndex) {
      this.$store.state.values.term_discount = parseFloat(event.target.value);
      this.$store.state.values.term_month = parseFloat(this.$store.state.wpdata[wpGlobalData.language].general[0].shop_general_laufzeit[selectedIndex].shop_general_laufzeit_month);
    },
    onChangePayment(event, selectedIndex) {
      this.$store.state.values.payment_discount = parseFloat(event.target.value);
      let paymentType = this.$store.state.wpdata[wpGlobalData.language].general[0].shop_general_payment[selectedIndex].shop_general_payment_type;
      this.$store.state.values.payment_type = paymentType;
      if(paymentType === 'monthly'){
        this.$store.state.values.payment_type_name = this.$store.state.wpdata[wpGlobalData.language].translations.slang_payment[0].slang_payment_monthly;
      }else if(paymentType === 'yearly'){
        this.$store.state.values.payment_type_name = this.$store.state.wpdata[wpGlobalData.language].translations.slang_payment[0].slang_payment_yearly;
      }else if(paymentType === 'one-off'){
        this.$store.state.values.payment_type_name = this.$store.state.wpdata[wpGlobalData.language].translations.slang_payment[0].slang_payment_oneoff;
      }
    },
    checkAddressForm(){
      this.$store.state.formSent = true;
      if(this.$store.state.addressComplete){
        this.redirectToStripe();
      }else{
        let element = document.getElementById('address');
        let top = element.offsetTop;
        window.scrollTo(0, top);
      }
    },
    redirectToStripe () {
      this.checkoutLoading = true;
      let data = {
        camera: this.$store.state.selections.selected_camera.shop_camera_options_type,
        analyse: this.$store.state.selections.selected_analyse.shop_analyse_options_type,
        term: this.$store.state.values.term_month,
        payment: this.$store.state.values.payment_type,
        language: wpGlobalData.language,
        addressData: this.$store.state.addressForm,
        delivery_type: this.$store.state.delivery_type,
        delivery_date: this.$store.state.delivery_date,
        show_offer: this.$store.state.showOffer
      }
      console.log(data);
      console.log(`${process.env.VUE_APP_API_URL}wp-json/wp/v2/shop/stripe/session`);

      axios.post(`${process.env.VUE_APP_API_URL}wp-json/wp/v2/shop/stripe/session`,data).then(function (response){
        console.log(response.data);
        window.location.href = response.data.req.data;
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StickyBar.vue